import { LOCALE } from 'locale'

import { Component, JSX, createUniqueId } from 'solid-js'
import { Show } from 'solid-js'
import { createStore, produce } from 'solid-js/store'

import { FarmError } from 'api'

import {
    CircleAlertIcon,
    CircleCheckBigIcon,
    OctagonXIcon,
    TriangleAlertIcon,
} from 'icons'

import './style/alert.scss'

type AlertModel = {
    type: 'info' | 'error' | 'success' | 'warn'
    id: string
    subject: string
    content?: string
    timeout: number
}

type State = {
    alerts: AlertModel[]
}

const [state, setState] = createStore<State>({
    alerts: [],
})

export function alert_add(a: Omit<AlertModel, 'id'>) {
    const id = createUniqueId()
    setState(
        produce(s => {
            s.alerts.unshift({ ...a, id })
        })
    )
}

export function alert_del(id: string) {
    const index = state.alerts.findIndex(a => a.id === id)

    if (index === -1) return

    setState(
        produce(s => {
            s.alerts.splice(index, 1)
        })
    )
}

const ALERT_ICON: {
    [x in AlertModel['type']]: () => JSX.Element
} = {
    info: () => <CircleAlertIcon />,
    error: () => <OctagonXIcon />,
    warn: () => <TriangleAlertIcon />,
    success: () => <CircleCheckBigIcon />,
}

type AlertProps = {
    a: AlertModel
    onDel(): void
}
const Alert: Component<AlertProps> = P => {
    let timer: HTMLDivElement

    return (
        <div
            class='alert'
            classList={{ [P.a.type]: true }}
            onMouseEnter={() => {
                let a = timer.getAnimations()[0]
                if (a) a.pause()
            }}
            onMouseLeave={() => {
                let a = timer.getAnimations()[0]
                if (a) a.play()
            }}
            onClick={P.onDel}
        >
            <div class='head title'>
                {ALERT_ICON[P.a.type]()}
                <span>{P.a.subject}</span>
                <div />
            </div>
            <Show when={P.a.content}>
                <div class='body title_smaller'>
                    <p>
                        {P.a.content!.split('\n').map(line => (
                            <>
                                {line}
                                <br />
                            </>
                        ))}
                    </p>
                </div>
            </Show>

            <div
                ref={r => (timer = r)}
                class='timer-line'
                onanimationend={P.onDel}
                style={{ 'animation-duration': `${P.a.timeout}s` }}
            ></div>
        </div>
    )
}

export const AlertFnd = () => {
    return (
        <div class='alert-fnd'>
            {state.alerts.map(a => (
                <Alert a={a} onDel={() => alert_del(a.id)} />
            ))}
        </div>
    )
}

export function alert_code(code: FarmError, debug?: string) {
    let msg = LOCALE.error(code)

    alert_add({
        type: 'error',
        timeout: 10,
        subject: msg,
        content: debug,
    })
}
